module.exports = __webpack_public_path__ + "img/FBB82D_FBEDBF_FBDE7D_FB7E05-256px.f3638752.png";